import { HTMLAttributes } from 'react';

interface InfoTableHelperProps extends HTMLAttributes<HTMLDivElement> {
	title: string;
	subTitle?: string;
}

export const InfoTableHelper = ({
	title,
	subTitle,
	className,
	...props
}: InfoTableHelperProps) => (
	<div className={`w-full ${className}`} {...props}>
		<p className='text-base text-white font-normal m-0 font-android'>{title}</p>
		{subTitle && (
			<p className='text-sm text-gray-400 font-light m-0 mt-1 !font-["Barlow"]'>{subTitle}</p>
		)}
	</div>
);
